import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	flex: 1 1 250px;
	min-width: 290px;
	height: 120px;
	padding: 20px;
	border-radius: 5px;
	border: 1px solid rgba(255, 255, 255, 0.1);
	background-color: rgba(255, 255, 255, 0.02);

	@media (max-width: 1500px) {
		min-width: 230px;
	}
`;

const StyledTitleContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;

	${Text} {
		&:first-child {
			font-size: 14px;
			color: #ffffff;
			opacity: 0.25;
		}

		&:last-child {
			font-weight: 500;
			font-size: 16px;
			color: #ffffff;
		}
	}
`;

const StyledTopContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledLevel = styled.div<{
	$isMaxLevel?: boolean;
	$isInactive?: boolean;
}>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
	border-radius: 40px;
	background-color: ${(props) =>
		props.$isMaxLevel
			? '#fabe2c'
			: props.$isInactive
			? 'rgba(255, 255, 255, 0.02)'
			: '#1782FF'};
	border: 1px solid
		${(props) =>
			props.$isInactive ? 'rgba(255, 255, 255, 0.05)' : 'transparent'};

	${Text} {
		font-weight: 700;
		font-size: 18px;
		color: ${(props) =>
			props.$isInactive || !props.$isMaxLevel ? '#ffffff' : '#000000'};
	}
`;

const StyledCenterContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 24px;

	${Text} {
		font-size: 14px;
		color: #ffffff;

		&:first-child {
			opacity: 0.5;
		}

		&:last-child {
			font-weight: 500;

			span {
				font-size: 12px;
				font-weight: 400;
				opacity: 0.5;
			}
		}
	}
`;

const StyledBottomContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 20px;
	gap: 10px;
	margin-top: 20px;
`;

const StyledProgressWrapper = styled.div`
	width: 100%;
	height: 20px;
	background: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 5px;
	padding: 1px;
`;

const StyledProgress = styled.div`
	height: 16px;
	background-color: #fabe2c;
	border-radius: 3px;
	transition: width 0.3s ease;
`;

export {
	StyledBottomContainer,
	StyledCenterContainer,
	StyledContainer,
	StyledLevel,
	StyledProgress,
	StyledProgressWrapper,
	StyledTitleContainer,
	StyledTopContainer,
};
